/* Rosas Home · capa de movimiento (sin dependencias)
   Revelados, difuminado entre secciones, color de fondo por sección,
   parallax, videos, ritual (bundle), satín, quiz y ventana de bienvenida. */
(function () {
  'use strict';
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = matchMedia('(hover: none)').matches;
  var raf = window.requestAnimationFrame.bind(window);
  /* Horizon desplaza dentro de .page-wrapper, no en la ventana */
  function scroller() { var pw = document.querySelector('.page-wrapper'); return (pw && pw.scrollHeight > pw.clientHeight + 10 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) ? pw : null; }
  function scrollTop() { var s = scroller(); return s ? s.scrollTop : (window.scrollY || 0); }
  function scrollMax() { var s = scroller(); return s ? (s.scrollHeight - s.clientHeight) : (document.documentElement.scrollHeight - innerHeight); }
  function onScrollTarget() { return scroller() || window; }

  /* ---------- utilidades ---------- */
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- 1. Titulares palabra por palabra ---------- */
  function splitWords(el) {
    if (el.dataset.rrSplit) return; el.dataset.rrSplit = '1';
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'rr-w';
            var i = document.createElement('span'); i.textContent = part; w.appendChild(i); frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !/^(BR)$/.test(n.tagName)) { walk(n); }
      });
    };
    walk(el);
    var words = el.querySelectorAll('.rr-w > span');
    words.forEach(function (s, i) { s.style.transitionDelay = (i * 0.07) + 's'; });
  }

  /* ---------- 2. Revelados ---------- */
  function initReveal(scope) {
    scope = scope || document;
    scope.querySelectorAll('.rr-words').forEach(splitWords);
    var els = scope.querySelectorAll('[data-rr-reveal], .rr-stagger, .rr-words, [data-rr-rule]');
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }
  var style = document.createElement('style');
  style.textContent = '[data-rr-rule]{transform:scaleX(0);transition:transform 1.4s cubic-bezier(.16,1,.3,1)}[data-rr-rule].is-in{transform:none}';
  document.head.appendChild(style);

  /* ---------- 3. Scroll: fondo por sección, difuminado, parallax ---------- */
  var sections = [], parallax = [], fades = [], ticking = false, lastMood = '';
  function collect() {
    sections = Array.prototype.slice.call(document.querySelectorAll('[data-rr-mood]'));
    parallax = Array.prototype.slice.call(document.querySelectorAll('[data-rr-parallax]'));
    fades = Array.prototype.slice.call(document.querySelectorAll('.rr-veil, .rr-hero')).map(function (sec) {
      var inner = sec.querySelector('.rr-container, .rr-container--narrow, .rr-hero__inner') || sec;
      inner.classList.add('rr-fade'); return { sec: sec, inner: inner };
    });
  }
  function onScroll() {
    if (ticking) return; ticking = true;
    raf(function () {
      ticking = false;
      var vh = innerHeight, mid = vh * 0.5;
      var best = null, bestD = Infinity;
      sections.forEach(function (s) {
        var r = s.getBoundingClientRect(); var c = r.top + r.height / 2;
        var d = Math.abs(c - mid) - r.height / 2; if (d < 0) d = 0;
        if (d < bestD) { bestD = d; best = s; }
      });
      if (best) {
        var mood = best.dataset.rrMood;
        if (mood !== lastMood) {
          lastMood = mood; document.documentElement.style.setProperty('--rr-mood', mood);
          if (window.RRCloth) window.RRCloth.setState(best.dataset.rrClothState || 'soft', mood);
        }
      }
      if (!reduced) fades.forEach(function (f) {
        var r = f.sec.getBoundingClientRect();
        var enter = clamp((vh - r.top) / (vh * 0.55), 0, 1);
        var exit = clamp((r.bottom) / (vh * 0.45), 0, 1);
        var v = Math.min(enter, exit);
        var eased = v * v * (3 - 2 * v);
        f.inner.style.opacity = (0.08 + 0.92 * eased).toFixed(3);
        f.inner.style.filter = isTouch ? '' : 'blur(' + ((1 - eased) * 10).toFixed(2) + 'px)';
      });
      if (!reduced) parallax.forEach(function (p) {
        var r = p.getBoundingClientRect(); var c = r.top + r.height / 2 - mid;
        var k = parseFloat(p.dataset.rrParallax) || 0.06;
        p.style.transform = 'translate3d(0,' + (-c * k).toFixed(1) + 'px,0)';
      });
      document.body.classList.toggle('rr-scrolled', scrollTop() > 40);
    });
  }

  /* ---------- 4. Videos: reproducir solo a la vista ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-rr-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- 5. Ritual (bundle) ---------- */
  var RRRitual = (function () {
    function Ritual(el) {
      this.el = el;
      try { this.data = JSON.parse(el.querySelector('[data-rr-variants]').textContent); } catch (e) { this.data = null; }
      if (!this.data) return;
      this.saving = parseInt(el.dataset.saving, 10) || 0;
      this.sel = {};
      var self = this;
      el.querySelectorAll('[data-rr-opt]').forEach(function (group) {
        var key = group.dataset.rrOpt; var first = group.querySelector('.rr-pill');
        self.sel[key] = first ? first.dataset.value : null;
        group.addEventListener('click', function (ev) {
          var b = ev.target.closest('.rr-pill'); if (!b) return;
          group.querySelectorAll('.rr-pill').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true'); self.sel[key] = b.dataset.value; self.update();
        });
      });
      var add = el.querySelector('[data-rr-add]');
      if (add) add.addEventListener('click', function () { self.add(add); });
      this.update();
    }
    Ritual.prototype.resolve = function () {
      var s = this.sel;
      var sheets = this.data.sheets.filter(function (v) {
        return (s['sheets-1'] == null || v.o1 === s['sheets-1']) && (s['sheets-2'] == null || v.o2 === s['sheets-2']);
      })[0];
      var combo = this.data.combo.filter(function (v) { return s['combo-1'] == null || v.o1 === s['combo-1']; })[0];
      return { sheets: sheets, combo: combo };
    };
    Ritual.prototype.update = function () {
      var r = this.resolve(); var el = this.el;
      var base = (r.sheets ? r.sheets.price : 0) + (r.combo ? r.combo.price : 0);
      var total = Math.max(base - this.saving, 0);
      var t = el.querySelector('[data-rr-total]'), b = el.querySelector('[data-rr-base]');
      if (t) t.textContent = money(total); if (b) b.textContent = money(base);
      var add = el.querySelector('[data-rr-add]');
      var ok = r.sheets && r.combo && r.sheets.available && r.combo.available;
      if (add) { add.disabled = !ok; add.setAttribute('aria-disabled', ok ? 'false' : 'true'); }
      this.current = r;
    };
    Ritual.prototype.add = function (btn) {
      var r = this.current; if (!r || !r.sheets || !r.combo) return;
      var forms = this.el.querySelectorAll('form[data-rr-bundle-form]');
      btn.setAttribute('aria-busy', 'true');
      var done = function () { btn.removeAttribute('aria-busy'); };
      if (forms.length === 2 && window.customElements && customElements.get('product-form-component')) {
        forms[0].querySelector('input[name="id"]').value = r.sheets.id;
        forms[1].querySelector('input[name="id"]').value = r.combo.id;
        forms[0].requestSubmit();
        setTimeout(function () { forms[1].requestSubmit(); setTimeout(done, 900); }, 1400);
        return;
      }
      fetch(this.el.dataset.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: r.sheets.id, quantity: 1 }, { id: r.combo.id, quantity: 1 }] }) })
        .then(function () { location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart'; })
        .catch(done);
    };
    return Ritual;
  })();

  /* ---------- 6. Escenario de satín (colores flotantes) ---------- */
  function initSatin(el) {
    var imgs = el.querySelectorAll('.rr-satin__img'), chips = el.querySelectorAll('[data-rr-chip]'), bg = el.querySelector('[data-rr-stage-bg]');
    if (!chips.length) return;
    function set(name, hex) {
      imgs.forEach(function (i) { i.classList.toggle('is-active', i.dataset.color === name); });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.rrChip === name ? 'true' : 'false'); });
      if (bg && hex) bg.style.setProperty('--rr-tint', hex);
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { set(c.dataset.rrChip, c.dataset.hex); }); });
    set(chips[0].dataset.rrChip, chips[0].dataset.hex);
    var i = 0, auto = setInterval(function () { i = (i + 1) % chips.length; set(chips[i].dataset.rrChip, chips[i].dataset.hex); }, 4200);
    el.addEventListener('click', function () { clearInterval(auto); }, { once: true });
  }

  /* ---------- 7. Quiz ---------- */
  function initQuiz(el) {
    var steps = el.querySelectorAll('.rr-quiz__step'), bar = el.querySelector('[data-rr-bar]'), result = el.querySelector('[data-result]');
    var answers = {}, i = 0;
    function show(n) {
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      if (bar) bar.style.width = ((n) / steps.length * 100) + '%';
    }
    function finish() {
      steps.forEach(function (s) { s.classList.remove('is-active'); }); if (bar) bar.style.width = '100%';
      var d = el.dataset, need = answers.need, who = answers.who, size = answers.size, color = answers.color || 'Marfil';
      var title, text, link;
      if (need === 'pelo') {
        title = d.comboTitle + ' · ' + color; link = d.comboUrl;
        text = (who === 'regalo' ? 'Un regalo que se usa todas las noches: ' : 'Tu ritual empieza en la almohada: ') + 'funda, bamba y gorro de satín en ' + color.toLowerCase() + '. ' + d.comboPrice + '.';
      } else if (need === 'cama') {
        title = d.sheetsTitle + (size ? ' · ' + size : '') + ' · ' + color; link = d.sheetsUrl;
        text = 'Sábanas cosidas a mano' + (size ? ' en tamaño ' + size.toLowerCase() : '') + ', en ' + color.toLowerCase() + ', con su bolsa de jacquard. ' + d.sheetsPrice + '.';
      } else {
        title = 'El ritual completo · ' + color; link = document.getElementById('rr-ritual') ? '#rr-ritual' : d.sheetsUrl;
        text = 'Sábanas' + (size ? ' ' + size.toLowerCase() : '') + ' + combo de satín en ' + color.toLowerCase() + '. Ahorras $15.000 y el envío es gratis.';
      }
      el.querySelector('[data-result-title]').textContent = title;
      el.querySelector('[data-result-text]').textContent = text;
      el.querySelector('[data-result-link]').setAttribute('href', link);
      result.classList.add('is-active');
    }
    el.addEventListener('click', function (ev) {
      var b = ev.target.closest('.rr-quiz__opt'); if (!b) return;
      answers[b.dataset.q] = b.dataset.v; i++;
      if (i >= steps.length) finish(); else show(i);
    });
    var restart = el.querySelector('[data-restart]');
    if (restart) restart.addEventListener('click', function () { answers = {}; i = 0; result.classList.remove('is-active'); show(0); });
    show(0);
  }

  /* ---------- 8. Ventana de bienvenida ---------- */
  function initPopup(el) {
    var key = 'rr_popup_ts', days = parseInt(el.dataset.days, 10) || 7, delay = (parseInt(el.dataset.delay, 10) || 8) * 1000;
    try { var ts = parseInt(localStorage.getItem(key) || '0', 10); if (ts && Date.now() - ts < days * 864e5) return; } catch (e) {}
    var shown = false;
    function open() { if (shown) return; shown = true; el.classList.add('is-open'); }
    function close() { el.classList.remove('is-open'); try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    setTimeout(open, delay);
    var tgt = onScrollTarget(); tgt.addEventListener('scroll', function onS() { if (scrollTop() > scrollMax() * 0.4) { open(); tgt.removeEventListener('scroll', onS); } }, { passive: true });
    el.querySelector('[data-rr-close]').addEventListener('click', close);
    var f = el.querySelector('form'); if (f) f.addEventListener('submit', function () { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} });
  }

  /* ---------- 9. Aviso en la pestaña (recupera visitas) ---------- */
  (function tabAttention() {
    var original = document.title;
    var msgs = ['🔥 ¡Vuelve!', '🔥 No olvides esto...'];
    var i = 0, timer = null;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        timer = setInterval(function () { document.title = msgs[i++ % msgs.length]; }, 1600);
      } else {
        if (timer) clearInterval(timer);
        document.title = original;
      }
    });
  })();

  /* ---------- arranque ---------- */
  function boot() {
    initReveal(); collect(); onScroll(); initVideos();
    document.querySelectorAll('rr-ritual').forEach(function (el) { if (!el.rr) el.rr = new RRRitual(el); });
    document.querySelectorAll('rr-satin-stage').forEach(function (el) { if (!el.rr) { el.rr = 1; initSatin(el); } });
    document.querySelectorAll('rr-quiz').forEach(function (el) { if (!el.rr) { el.rr = 1; initQuiz(el); } });
    document.querySelectorAll('rr-popup').forEach(function (el) { if (!el.rr) { el.rr = 1; initPopup(el); } });
  }
  function bindScroll() { onScrollTarget().addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('scroll', onScroll, { passive: true }); }
  addEventListener('resize', function () { collect(); onScroll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bindScroll(); boot(); }); else { bindScroll(); boot(); }
  document.addEventListener('shopify:section:load', function () { boot(); });
  window.RRMotion = { refresh: boot };
})();
